import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';

//import { TestService } from 'src/app/_services/test.service';

import { TestService } from './../../_services/test.service';
import {MatSnackBar} from '@angular/material';
import { OrganisationsService } from 'app/_services/organisations.service';

//organisations.service

@Component({
  selector: 'app-addedittest',
  templateUrl: './addedittest.component.html',
  styleUrls: ['./addedittest.component.css']
})
export class AddedittestComponent implements OnInit {

  productLoading:Boolean=false
  orgtypeselectedValue:any
  organizationType:any
  test: any =
  {
  utoken:localStorage.getItem("utoken"),
  usermasterid:localStorage.getItem("user_master_id"),
  testid: 0,
  testname: '',
  orgtype:'',

  status: 'Active'
  };
  errorMessage: string;
  submitted = false;
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar:MatSnackBar,
    private orgservice: OrganisationsService,
    private testService:TestService) { }

  ngOnInit() 
  {
this.getOrganizationType()

this.route.params.subscribe(
params => {
if(this.route.snapshot.params.testid)
{
this.testService.getedittestdata(this.route.snapshot.params.testid)
.subscribe(
 data => {

  //service_type


this.test.testid=data.Data[0].test_master_id
this.test.testname=data.Data[0].test_name
this.test.status=data.Data[0].status
this.test.orgtype=data.Data[0].service_type
this.orgtypeselectedValue=data.Data[0].service_type

})
}
})
  
}

  onSubmit() 
  {


console.log("test",this.test)

    this.submitted = true;

this.productLoading=true

this.testService.createtest(this.test)
 .subscribe(
    data => {
    if(data.status_code==200)
    {

      this.productLoading=false

      this.snackbar.open(data.Metadata.Message, 'close', {
        duration: 3000,
        verticalPosition:"top",
        extraClasses: ['bg-green']
      });



    this.router.navigate(['/test']);
    }
    else
    {
      
 this.snackbar.open(data.Metadata.Message, 'close', {
  duration: 3000,
  verticalPosition:"top",
  extraClasses: ['bg-red']
}); 

this.productLoading=false   
      
      }
    })
   }


   getOrganizationType(){
    this.orgservice.getOrganizationType().subscribe((response)=>{
  
  console.log("response.Data",response.Data)
  
        this.organizationType = response.Data
    })
  }

   /*
if(this.test.testid==0)
{
 this.testService.createtest(this.test)
 .subscribe(
    data => {
    if(data.status_code==200)
    {
    this.router.navigate(['/test']);
    }
    else
    {
    this.errorMessage=data.Metadata.Message
    }
    })
   }
    else
    {
      this.testService.createtest(this.test)
      .subscribe(
      data => {
      if(data.status_code==200)
      {
      this.router.navigate(['/test']);
      }
      else
      {
      this.errorMessage=data.Metadata.Message
      }
      })
  }
  */    
  }


// WEBPACK FOOTER //
// ./src/app/component/addedittest/addedittest.component.ts